import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ReactMarkdown from 'react-markdown';
import privacyPolicyPath from '../content/privacy-policy.md';
import './PrivacyPolicyPage.css';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [policyMarkdown, setPolicyMarkdown] = useState('');
  const backLabel = isAuthenticated ? 'Back to app' : 'Back to sign in';
  const backPath = isAuthenticated ? '/support' : '/';

  useEffect(() => {
    let isMounted = true;

    async function loadPrivacyPolicy() {
      try {
        const response = await fetch(privacyPolicyPath);
        const markdown = await response.text();

        if (isMounted) {
          setPolicyMarkdown(markdown);
        }
      } catch {
        if (isMounted) {
          setPolicyMarkdown('# Privacy Policy\n\nUnable to load the privacy policy right now.');
        }
      }
    }

    loadPrivacyPolicy();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Box className="privacy-policy-page">
      <Paper className="privacy-policy-card" elevation={1}>
        <Stack spacing={2.5}>
          <Box>
            <Button
              variant="text"
              size="small"
              onClick={() => navigate(backPath)}
              sx={{ px: 0, minWidth: 0 }}
            >
              {backLabel}
            </Button>
          </Box>
          <ReactMarkdown>{policyMarkdown}</ReactMarkdown>
        </Stack>
      </Paper>
    </Box>
  );
}
